import React from 'react';
import { Control, Fieldset } from 'react-redux-form';
import InputField from './Controls/Field';
import SurveyOption from './Controls/SurveyOption';

import './styles.css';

const fields = [
  {
    model: '.passive',
    RRFComp: Control.checkbox,
    checkLabel: 'Passive Income',
    control: {
      isToggle: true,
      component: SurveyOption,
      checked: false,
    },
  },
  {
    model: '.hotStartups',
    RRFComp: Control.checkbox,
    checkLabel: 'Aggressive Growth',
    control: {
      isToggle: true,
      component: SurveyOption,
      checked: false,
    },
  },
  {
    model: '.anything',
    RRFComp: Control.checkbox,
    checkLabel: 'Anything',
    control: {
      isToggle: true,
      component: SurveyOption,
    },
  },
];

const InterestSurvey = ({ surveyPath }) => (
  <Fieldset model={surveyPath}>
    {fields.map(field => (
      <InputField
        id={field.model}
        fieldProps={field}
        key={field.model}
      >
        {field.checkLabel}
      </InputField>))}
  </Fieldset>
);

export default InterestSurvey;




// WEBPACK FOOTER //
// ./src/components/Forms/InterestSurvey.js